export const MENU_RELOAD_INTERVAL = 15 * 60 * 1000
export function realtimeUrlFor(value, pageUrl) {
  const page = new URL(pageUrl)
  const local = ['localhost', '127.0.0.1', '[::1]'].includes(page.hostname)
  const labels = page.hostname.toLowerCase().split('.')
  if (labels.length > 2 && ['www', 'app', 'menu'].includes(labels[0])) labels.shift()
  const fallback = local ? 'ws://localhost:3097' : `wss://websockets.${labels.join('.')}`
  try {
    const url = new URL(String(value || '').trim())
    if (!['ws:', 'wss:'].includes(url.protocol) || url.username || url.password || url.hash || (page.protocol === 'https:' && url.protocol !== 'wss:') || (!local && ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname))) return fallback
    return url.href
  } catch (_e) { return fallback }
}
export function createMenuReloadFallback({ now = () => Date.now(), online = () => navigator.onLine, probe, reload, interval = MENU_RELOAD_INTERVAL }) {
  let outageStarted = now(); let connected = false; let checking = false; let destroyed = false; let reloading = false; let notice = ''; let nextProbe = 0
  return {
    status(value) { if (value.connected) { connected = true; outageStarted = null; notice = '' } else { if (connected || outageStarted === null) outageStarted = now(); connected = false } },
    snapshot() { return { connected, checking, notice, dueIn: connected || outageStarted === null ? null : Math.max(0, interval - (now() - outageStarted)), reloading } },
    async tick() {
      if (destroyed || checking || reloading || connected || outageStarted === null || now() - outageStarted < interval || now() < nextProbe || !online()) return false
      checking = true
      try {
        const reachable = await probe()
        if (destroyed || connected || !online()) return false
        if (!reachable) { notice = 'La web no respondió. Se conserva el menú y se reintentará.'; nextProbe = now() + 60000; return false }
        reloading = true; reload(); return true
      } catch (_e) { notice = 'La web no respondió. Se conserva el menú y se reintentará.'; nextProbe = now() + 60000; return false }
      finally { checking = false }
    },
    stop() { destroyed = true }
  }
}
